import React from "react";
export const FloatingSessionContext = React.createContext(null)